export enum ProductTypes {
  // Package Products
  STANDARD_PACKAGE = 'standard_package',
  FULL_SUITE = 'full_suite',

  // Standalone Services
  MAILROOM = 'mailroom',
  REGISTERED_AGENT = 'registered_agent',
  FEDERAL_TAX = 'federal_tax',
  FEDERAL_TAX_LATE = 'federal_tax_late',
  STATE_TAX = 'state_tax',
  ACCOUNTING = 'accounting',

  // One-time Fees
  STATE_FEE = 'state_fee',
}
